import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import { appdata } from '../internalModules'
import UIWallTypeCard from './UIWallTypeCard';
import { Box, Button, Grid } from '@mui/material';
import {WallType} from '../internalModules';
import { Dist } from '../Dist';
import UIWallTypeList3d from './UIWallTypeList3d';
import {WallTypeRibbon} from '../internalModules';
import {WallTypeWindow} from '../internalModules';
import {WallTypeCurtain} from '../internalModules';
import { ReactComponent as IconWindow } from '../icons/IconWindow.svg'
import { ReactComponent as IconWall } from '../icons/IconWall.svg'
import { ReactComponent as IconRibbon } from '../icons/IconRibbon.svg'
import { ReactComponent as IconCurtain } from '../icons/IconCurtain.svg'
import { ReactComponent as IconFloor } from '../icons/IconFloor.svg'
import AddIcon from '@mui/icons-material/Add'
import Tooltip from '@mui/material/Tooltip'
import {AssemblyHorizontal} from '../internalModules';
import { TrackAnalyticsEvent } from '../analytics/analytics';
import { CreateAssemblyCurtainEvent, CreateAssemblyEvent, CreateAssemblyHorizontalEvent, CreateAssemblyRibbonEvent, CreateAssemblyWindowEvent } from '../analytics/events';

type Props = {
  updateApp: Function,
  assemblies: WallType[]
}

export default function UIWallTypeList({updateApp, assemblies}: Props) {

  const iconSize = 90
  const buttonVariant = 'contained'
  const buttonStyle = {padding: 1}

  const handleAddWallType = () => {
    appdata.createWallType( new WallType(Dist.feet(12), Dist.feet(15)) )
    TrackAnalyticsEvent(CreateAssemblyEvent)
    updateApp()
  }

  const handleAddRibbonWall = () => {
    appdata.createWallType( new WallTypeRibbon(Dist.feet(12), Dist.feet(15), 0.6) )
    TrackAnalyticsEvent(CreateAssemblyRibbonEvent)
    updateApp()
  }

  const handleAddWindowWall = () => {
    appdata.createWallType( new WallTypeWindow(Dist.feet(12), Dist.feet(15), 0.4) )
    TrackAnalyticsEvent(CreateAssemblyWindowEvent)
    updateApp()
  }

  const handleAddCurtainWall = () => {
    appdata.createWallType( new WallTypeCurtain(Dist.feet(12), Dist.feet(15), 0.8) )
    TrackAnalyticsEvent(CreateAssemblyCurtainEvent)
    updateApp()
  }

  const handleAddHorizontalAssembly = () => {
    appdata.createWallType( new AssemblyHorizontal(Dist.feet(14.5), Dist.feet(30), Dist.feet(30)) )
    TrackAnalyticsEvent(CreateAssemblyHorizontalEvent)
    updateApp()
  }

  const deleteWallType = (guid: string) => {
    appdata.deleteWallType(guid)
    updateApp()
  }
  
  return (
    <Box sx={{padding:2}}>
      <List>
        {assemblies.sort( (a, b) => a.name.localeCompare(b.name)).map(item => (
          <UIWallTypeCard
            key={item.guid}
            walltype={item}
            deleteWallType={deleteWallType}
            updateApp={updateApp}
          />
        ))}
      </List>

      <Grid container p={3}>
        <Grid item xs={4}/>
        <Grid item sm={7.75} xl={7}>
          <Paper sx={{p:2}}>
            <Grid container flexDirection={'row'} spacing={1}>
              <Grid item sm={2.4}>
                <Tooltip title='Add vertical assembly' arrow>
                  <Button
                    variant={buttonVariant}
                    sx={buttonStyle}
                    fullWidth
                    onClick={handleAddWallType}
                  >
                    <AddIcon fontSize='medium'/>
                    <IconWall height={iconSize}/>
                  </Button>
                </Tooltip>
                
              </Grid>

              <Grid item sm={2.4}>
                <Tooltip title='Add ribbon window assembly' arrow>
                  <Button
                    variant={buttonVariant}
                    sx={buttonStyle}
                    fullWidth
                    onClick={handleAddRibbonWall}
                  >
                    <AddIcon fontSize='medium'/>
                    <IconRibbon height={iconSize}/>
                  </Button>
                </Tooltip>
              </Grid>

              <Grid item sm={2.4}>
                <Tooltip title='Add window assembly' arrow>
                  <Button
                    variant={buttonVariant}
                    sx={buttonStyle}
                    fullWidth
                    onClick={handleAddWindowWall}
                  >
                    <AddIcon fontSize='medium'/>
                    <IconWindow height={iconSize}/>
                  </Button>
                </Tooltip>
              </Grid>
              
              <Grid item sm={2.4}>
                <Tooltip title='Add curtain wall assembly' arrow>
                  <Button
                    variant={buttonVariant}
                    sx={buttonStyle}
                    fullWidth
                    onClick={handleAddCurtainWall}
                  >
                    <AddIcon fontSize='medium'/>
                    <IconCurtain height={iconSize}/>
                  </Button>
                </Tooltip>
              </Grid>

              <Grid item sm={2.4}>
                <Tooltip title='Add horizontal assembly' arrow>
                  <Button
                    variant={buttonVariant}
                    sx={buttonStyle}
                    fullWidth
                    onClick={handleAddHorizontalAssembly}
                  >
                    <AddIcon fontSize='medium'/>
                    <IconFloor height={iconSize}/>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
            
          </Paper>
        </Grid>
      </Grid>

      <UIWallTypeList3d assemblies={assemblies}/>

    </Box>
  );
}
